import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import { I18nRaw } from 'components';
import messages from './messages';

export const getMessage = (path) => (
  R.path(path.split('.'), messages)
);

const I18n = ({ path = '', vars = {}, className, style }) => {
  const html = getMessage(path);

  return (
    <I18nRaw
      style={style}
      className={className}
      html={html}
      vars={vars}
    />
  );
};

I18n.propTypes = {
  path: PropTypes.string,
  vars: PropTypes.object,
  className: PropTypes.any,
  style: PropTypes.object,
};

export default I18n;
